import { Controller } from "@hotwired/stimulus"
import { getUserId } from "@lib/utils"

// Connects to data-controller="user-only"
export default class extends Controller {
  static values = { id: Number }

  initialize() {
    if (this.idValue === getUserId()) this.element.classList.remove("hidden")
  }
  
}
